<template>
  <v-app light>
    <v-app-bar app :src="getBannerSrc()" :height="100" flat>
      <template v-slot:img="{ props }">
        <v-img v-bind="props"></v-img>
      </template>
    </v-app-bar>
    <v-content>
      <v-container fluid v-show="showMain">
        <v-row align="end">
          <v-card class="mx-auto" align="center" flat>
            <v-card-text class="headline font-weight-bold mt-2" align="center">
              <div>{{ labels.processing[language] }}</div>
              <br />
              <v-progress-linear indeterminate height="20" color="primary"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container fluid v-show="showError">
        <v-row style="height: 100pt" align="end">
          <v-card class="mx-auto" align="center" flat>
            <v-img width="100" :src="require('../assets/image/error.png')" @click="handleImageOnClick">
            </v-img>
          </v-card>
        </v-row>
        <v-row style="height: 100pt" align="end" justify="center">
          <div v-show="showErrorMessage" class="headline" style="width:80%">
            {{ errorMessage }}
          </div>
          <div v-show="!showErrorMessage" class="headline font-weight-bold">{{ errorText }}</div>
        </v-row>
      </v-container>
    </v-content>
    <v-footer padless app color="white">
      <v-container v-show="showHome" fluid>
        <v-row class="pa-0">
          <v-col class="pr-0 pl-0">
            <v-btn height="70" class="subtitle-1" color="primary" @click="home" x-large block outlined>{{
              labels.home[language] }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { deepCopy } from '../assets/functions/deepCopy';

const PosTransaction = require('../modules/pos_transaction');

export default {
  name: 'UploadPage',
  components: {},
  props: {},
  data: () => ({
    labels: {
      processing: {
        en_US: 'Processing...',
        zh_TW: '作業處理中，請稍後',
      },
      error: {
        en_US: 'Error!! Please contact our staff.',
        zh_TW: '上傳交易發生錯誤！',
      },
      home: {
        en_US: 'HOME',
        zh_TW: '返回首頁',
      },
    },
    showMain: true,
    showError: false,
    showErrorMessage: false,
    showHome: false,
    errorText: '',
    errorMessage: '',
  }),
  methods: {
    getBannerSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskHomePageBanner) {
        return setting.kioskHomePageBanner.url + setting.kioskHomePageBanner.file_name;
      }
      return '';
    },
    handleImageOnClick() {
      this.showMain = false;
      this.showHome = true;
      this.showError = true;
      this.showErrorMessage = true;
    },
    home() {
      this.$store.dispatch('cleanOrder');
      this.$router.push('/');
    },
    goNext() {
      const next = this.$store.getters.nextStatusText;
      this.$router.push(next);
    },

  },
  mounted() {
    if (this.$store.getters.onlyDoPrime) {
      const { tContent, token } = this.$store.getters;
      const data = deepCopy(tContent);
      const { paymentType } = this.$store.getters.order;
      data.paymentType = paymentType;
      const { prime } = this.$store.getters;
      if (prime?.type) {
        data.paymentType.storePaymentType.subPaymentTypeName = paymentType.name;
        data.prime = deepCopy(prime);
      }
      PosTransaction
        .updateTransaction(token, data)
        .then((res) => {
          if (res.data) {
            const _res = res.data;
            if (_res.rs === 'OK') {
              const _resData = _res.jsonData;
              this.$store.dispatch('setStatus', 'UPLOAD');
              this.$store.dispatch('setPosResponse', _resData)
                .then(async () => {
                  if (this.$store.getters.order.paymentType.name === 'linepay') {
                    const { paymentUrl } = _resData.info;
                    if (paymentUrl) {
                      const { isLinePayTest } = this.$store.getters;
                      if (!isLinePayTest) {
                        // eslint-disable-next-line no-restricted-globals
                        location.href = paymentUrl.app;
                      } else {
                        window.open(paymentUrl.web);
                      }
                    }
                  }
                  if (prime?.type) {
                    const postData = {
                      action: 'tp.PayByPrime',
                      clientTransactionId: '',
                      transactionId: '',
                      POSTransaction: {},
                      requestObject: deepCopy(prime.primeData),
                    };
                    const { transactionId, clientTransactionId } = tContent;
                    if (transactionId.length > 0 && clientTransactionId.length > 0) {
                      postData.transactionId = transactionId;
                      postData.clientTransactionId = clientTransactionId;
                    } else {
                      postData.POSTransaction = res.tContent;
                    }
                    const { token } = this.$store.getters;
                    if (token) {
                      const rst = await PosTransaction.doTapPayByPrime(token, postData);
                      // console.log('rst', rst);
                      if (rst.data.rs === 'OK' && rst.data.responseObject.status === 0) {
                        const link = rst.data.responseObject.payment_url;
                        window.location.replace(link);
                      }
                    }
                  }
                  this.goNext();
                });
            }
            if (_res.rs === 'NG') {
              this.errorText = this.labels.error[this.language];
              this.errorMessage = (_res.error) ? `${_res.transactionId}: ${_res.error}` : _res;
              this.showError = true;
              this.showMain = false;
            }
          }
        })
        .catch((e) => {
          console.log('error', e);
        });
    }
    if (!this.$store.getters.posResponse) {
      const content = {
        token: this.$store.getters.token,
        data: {
          ...this.$store.getters.order,
          totalAmount: this.$store.getters.totalAmount,
          totalServiceFee: this.$store.getters.totalServiceFee,
        },
      };
      const {
        QrcodeData, storeId, previousOrder, previousTotal,
      } = this.$store.getters;
      content.data.QrcodeData = QrcodeData;
      content.data.storeId = storeId;
      if (previousOrder.length > 0) {
        content.data.log = previousOrder;
        content.data.totalAmount = (this.$store.getters.totalAmount + previousTotal.previousTotalAmount);
        content.data.totalServiceFee = (this.$store.getters.totalServiceFee + previousTotal.previousTotalServiceFee);
        this.$store.dispatch('setCurrentOrder', PosTransaction.sortLog(PosTransaction.itemsToLog(content.data.items)));
      }

      const { prime } = this.$store.getters;
      if (prime?.type) {
        content.data.paymentType.storePaymentType.subPaymentTypeName = content.data.paymentType.name;
        content.data.prime = prime;
      }
      // console.log('update dotrans', content.data);
      PosTransaction
        .doTransaction(content.token, content.data)
        .then(async (res) => {
          if (res.tContent) {
            this.$store.dispatch('settContent', res.tContent);
          }
          if (prime?.type) {
            const postData = {
              action: 'tp.PayByPrime',
              clientTransactionId: '',
              transactionId: '',
              POSTransaction: {},
              requestObject: deepCopy(prime.primeData),
            };
            const { transactionId, clientTransactionId } = QrcodeData;
            if (transactionId.length > 0 && clientTransactionId.length > 0) {
              postData.transactionId = transactionId;
              postData.clientTransactionId = clientTransactionId;
            } else {
              postData.POSTransaction = res.tContent;
            }
            const { token } = this.$store.getters;
            if (token) {
              const rst = await PosTransaction.doTapPayByPrime(token, postData);
              // console.log('rst', rst);
              if (rst.data.rs === 'OK' && rst.data.responseObject.status === 0) {
                const link = rst.data.responseObject.payment_url;
                window.location.replace(link);
              }
            }
          }
          if (res.data) {
            const _res = res.data;
            if (_res.rs === 'OK') {
              const _resData = _res.jsonData;
              this.$store.dispatch('setStatus', 'UPLOAD');
              this.$store.dispatch('setPosResponse', _resData)
                .then(async () => {
                  if (this.$store.getters.order.paymentType.name === 'linepay') {
                    const { paymentUrl } = _resData.info;
                    if (paymentUrl) {
                      const { isLinePayTest } = this.$store.getters;
                      if (!isLinePayTest) {
                        // eslint-disable-next-line no-restricted-globals
                        location.href = paymentUrl.app;
                      } else {
                        window.open(paymentUrl.web);
                      }
                    }
                  }
                  // if (prime?.type) {
                  //   const postData = {
                  //     action: 'tp.PayByPrime',
                  //     clientTransactionId: '',
                  //     transactionId: '',
                  //     POSTransaction: {},
                  //     requestObject: deepCopy(prime.primeData),
                  //   };
                  //   const { transactionId, clientTransactionId } = QrcodeData;
                  //   if (transactionId.length > 0 && clientTransactionId.length > 0) {
                  //     postData.transactionId = transactionId;
                  //     postData.clientTransactionId = clientTransactionId;
                  //   } else {
                  //     postData.POSTransaction = res.tContent;
                  //   }
                  //   const { token } = this.$store.getters;
                  //   if (token) {
                  //     const rst = await PosTransaction.doTapPayByPrime(token, postData);
                  //     console.log('rst', rst);
                  //     if (rst.data.rs === 'OK' && rst.data.responseObject.status === 0) {
                  //       const link = rst.data.responseObject.payment_url;
                  //       window.location.replace(link);
                  //     }
                  //   }
                  // }
                  this.goNext();
                });
            }
            if (_res.rs === 'NG') {
              this.errorText = this.labels.error[this.language];
              this.errorMessage = (_res.error) ? `${_res.transactionId}: ${_res.error}` : _res;
              this.showError = true;
              this.showMain = false;
            }
          }
        })
        .catch((e) => {
          console.log('error', e);
        });
    }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    processStatus: {
      get() {
        return this.$store.getters.statusText;
      },
    },
  },
};

</script>
<style></style>
